import { CONFIG, FREE_SHIPPING_THRESHOLD } from 'shared/constants'
import { numberToCurrency } from 'lib/money'
import { Tooltip } from 'baby-design'
import { Info } from 'baby-design/icons'
import { freeShippingFaqPath, registryDiscountPath } from 'lib/urls'
import css from './hero.scss'

const StoreHero = () => (
  <div className={css.StoreHero}>
    <h1 className={css.StoreHero__title}>Babylist Shop</h1>
    <div className={css.StoreHero__body}>
      Curated by experts and tested by parents. Enjoy free shipping on{' '}
      {numberToCurrency(FREE_SHIPPING_THRESHOLD, {
        truncateZeroCents: true,
        unit: '$',
      })}
      +
      <Tooltip
        content={
          <div className={css.StoreHero__tooltip__content}>
            We gladly accept returns on items purchased directly from the
            Babylist Shop within 9 months of purchase date. Returned items must
            be in the same condition received, unopened and in the original
            packaging. For more details,{' '}
            <a href={registryDiscountPath} rel="noreferrer" target="_blank">
              view our full return policy
            </a>
            .
          </div>
        }
        position="bottom"
        trigger={<Info className={css.StoreHero__tooltip__icon} />}
        triggerClassName={css.StoreHero__tooltip}
      />
      and an exclusive {CONFIG.store?.registryDiscountPctDisplay} registry
      discount.
      <Tooltip
        content={
          <div className={css.StoreHero__tooltip__content}>
            Enjoy 15% off in the Babylist Shop 60 days before your baby's
            expected arrival date. This discount is applicable only to items
            sold directly by Babylist Shop and can't be used for purchases at
            other stores or websites. To qualify, you must have an active
            registry for at least 30 days.{' '}
            <a href={freeShippingFaqPath} rel="noreferrer" target="_blank">
              Some exclusions may apply
            </a>
            .
          </div>
        }
        position="bottom"
        trigger={<Info className={css.StoreHero__tooltip__icon} />}
        triggerClassName={css.StoreHero__tooltip}
      />
    </div>
  </div>
)

export default StoreHero
